import { gql } from '@apollo/client';

export default gql`
  mutation createMultiOperationFinance($ids: [String]) {
    createMultiOperationFinance(ids: $ids) {
      ok
      message
      data
      error
    }
  }
`;
